'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '-1.5 -3 16 16', width: '100%', height: '100%' },
          _react2.default.createElement('path', { d: 'M3 0h10v1H3V0zm0 3h10v1H3V3zm0 3h10v1H3V6zM0 0h1v1H0V0zm0 3h1v1H0V3zm0 3h1v1H0V6zm3 3h10v1H3V9zM0 9h1v1H0V9z', fill: color })
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'List';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/List.js
// module id = 1078
// module chunks = 0